// TermsAndCondition

import React from 'react';
import CyberSafety from 'views/CyberSafety';

const StudentsTestimonialpage = () => {
  return <CyberSafety />;
};

export default StudentsTestimonialpage;